import script from "./noData.vue?vue&type=script&setup=true&lang=js"
export * from "./noData.vue?vue&type=script&setup=true&lang=js"

import "./noData.vue?vue&type=style&index=0&id=edcefad2&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edcefad2"]])

export default __exports__